import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';
import { StoreDetailService } from 'src/app/modules/shared/services/resolver/store-detail.service';
import { WalletBalanceService } from 'src/app/modules/shared/services/resolver/wallet-balance.service';
import { LocalStorageService } from 'src/app/modules/shared/services/storage/local-storage.service';
import { StateService } from 'src/app/modules/shared/services/storage/state.service';
import { AuthenticateService } from '../../services/authenticate.service';
import {
  RecaptchaVerifier,
  getAuth,
  signInWithPhoneNumber,
} from '@firebase/auth';
import { initializeApp } from 'firebase/app';
import { WindowService } from '../../services/window.service';
import { SnackBarService } from 'src/app/modules/shared/services/snack-bar.service';
import { ProfileResolverService } from 'src/app/modules/shared/services/resolver/profile-resolver.service';
import { GoogleTagManagerService } from 'src/app/modules/shared/services/google-tag-manager.service';
import {
  CountryDetail,
  Profile,
} from 'src/app/modules/shared/models/profile.mode';
import { MatDialog } from '@angular/material/dialog';
import { DeviceDetectorService } from 'src/app/modules/shared/services/device-detector/device-detector.service';
import { FACEBOOK_EVENT_TYPES } from 'src/app/modules/shared/services/meta-pixel/meta-pixel.model';
import { MetaPixelService } from 'src/app/modules/shared/services/meta-pixel/meta-pixel.service';

export class PhoneNumber {
  number: any;

  constructor() {}
}
@Component({
  selector: 'app-sms-verification',
  templateUrl: './sms.component.html',
  styleUrls: ['./sms.component.scss'],
})
export class SmsComponent implements OnInit {
  @Input('isEditPhoneMode') isEditPhoneMode: boolean = false;
  @Output() isEditPhoneVerifyMode = new EventEmitter<any>();

  smsLoginForm: FormGroup = new FormGroup({});
  verification_code: FormControl = new FormControl('', [
    Validators.required,
    Validators.maxLength(6),
    Validators.pattern('^[0-9]*$'),
  ]);
  isVerificationStep: boolean = false;
  subscriptions: Subscription[] = [];
  storeDetail;
  remainingTime = {
    timer: 120000,
    seconds: '00',
    minutes: '02',
  };
  windowRef: any;
  phoneNumber = new PhoneNumber();
  profileData: Profile;
  verificationCode: any;
  user: any;
  recaptchaChecked: boolean = false;
  resendRecaptcha: boolean = false;
  countryList: CountryDetail[];
  filteredCountryList: CountryDetail[];
  selected: any;
  countryCode: any;
  buyingProductId;
  buyingProductName;
  isOtpCodeInvalid: boolean = false;
  isDesktop: boolean = false;
  isActionDisabled: boolean = false;
  verificationCodeForm: FormGroup = new FormGroup({});
  @ViewChild('stroke') strokeCircle: any;
  constructor(
    private authenticateService: AuthenticateService,
    private stateService: StateService,
    private localStorage: LocalStorageService,
    private router: Router,
    private storeDetailResolver: StoreDetailService,
    private googleTagManagerService: GoogleTagManagerService,
    private win: WindowService,
    private panelService: PanelService,
    private snackBarService: SnackBarService,
    private zone: NgZone,
    private profileResolver: ProfileResolverService,
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private dialog: MatDialog,
    private metaPixelService: MetaPixelService,
    private deviceDetectorService: DeviceDetectorService
  ) {
    this.isDesktop = this.deviceDetectorService.isDesktop;
    if (this.router.url.includes('edit')) {
      this.isEditPhoneMode = true;
    }
  }

  ngOnInit(): void {
    this.isEditPhoneMode && this.getProfileData();
    this.getStoreDetail();

    this.windowRef = this.win.windowRef;
    const auth = getAuth();
    this.windowRef.recaptchaVerifier = new RecaptchaVerifier(
      'recaptcha-container',
      {
        callback: (w) => {
          this.recaptchaChecked = true;
          this.isActionDisabled = false;
        },
        'expired-callback': () => {
          this.recaptchaChecked = false;
          this.isActionDisabled = true;
        },
      },
      auth
    );
    this.windowRef.recaptchaVerifier.render();
    this.initForms();
    this.getCountries();
    this.checkAccessParam();
  }

  private getProfileData() {
    this.profileResolver.permissionInitInfo.subscribe((data) => {
      this.profileData = data;
    });
  }

  checkAccessParam() {
    const routeParam = this.activatedRoute.queryParams.subscribe((params) => {
      if (params.product && params.name) {
        this.buyingProductId = params.product;
        this.buyingProductName = params.name;
      } else {
        this.buyingProductId = '';
        this.buyingProductName = '';
      }
    });

    this.subscriptions.push(routeParam);
  }

  private filterCountries(keyword: string) {
    const searchTextLower = keyword.toLowerCase();
    this.filteredCountryList = this.countryList.filter((country) =>
      country.name.toLowerCase().includes(searchTextLower)
    );
  }

  ngOnDestroy() {
    this.unsubscribeSubscriptions();
  }

  unsubscribeSubscriptions() {
    if (this.subscriptions.length > 0) {
      this.subscriptions.forEach((subscription) => {
        subscription.unsubscribe();
      });
    }
  }
  getCountries() {
    this.panelService.getCountryList({ ordering: 'name' }).subscribe((data) => {
      this.countryList = data;
      this.filteredCountryList = this.countryList;
      this.smsLoginForm
        .get('country_field')
        ?.patchValue(
          this.filteredCountryList?.find(
            (element: any) => element.is_country_of_request == true
          )
        );
    });
  }

  initForms() {
    this.smsLoginForm = new FormGroup({
      country_field: new FormControl('', Validators.required),
      country_search: new FormControl(''),
      number: new FormControl('', [
        Validators.required,
        Validators.maxLength(15),
      ]),
    });

    this.smsLoginForm
      .get('country_search')
      .valueChanges.subscribe((keyword) => {
        this.filterCountries(keyword);
      });

    this.smsLoginForm.get('country_field')?.valueChanges.subscribe((value) => {
      this.smsLoginForm.get('number')?.disable();
      const numberControl = this.smsLoginForm.get('number');
      numberControl.setValue('', { emitEvent: false });
      if (value?.phone_prefix) {
        numberControl?.enable();
        numberControl?.setValidators([
          Validators.required,
          Validators.maxLength(15),
        ]);
        numberControl?.updateValueAndValidity();
      }
    });
    this.smsLoginForm.get('country_field')?.valueChanges.subscribe((value) => {
      this.selected = value;
    });

    this.verificationCodeForm = new FormGroup({
      character1: new FormControl('', [Validators.required]),
      character2: new FormControl('', [Validators.required]),
      character3: new FormControl('', [Validators.required]),
      character4: new FormControl('', [Validators.required]),
      character5: new FormControl('', [Validators.required]),
      character6: new FormControl('', [Validators.required]),
    });
  }

  get numberField() {
    return this.smsLoginForm.get('number')?.value;
  }

  get countryField() {
    return this.smsLoginForm.get('country_field')?.value?.phone_prefix;
  }

  get formattedNumberField() {
    return this.numberField.split();
  }

  getStoreDetail() {
    this.storeDetail = this.storeDetailResolver.permissionInit;
    initializeApp(this.storeDetail.firebase_config);
  }

  startTimer() {
    this.remainingTime = {
      timer: 120000,
      seconds: '00',
      minutes: '02',
    };
    this.unsubscribeSubscriptions();
    const source = interval(1000);
    const remainTimer = source
      .pipe(takeWhile((val) => this.unsubscribeTimer()))
      .subscribe((val) => {
        let seconds = this.remainingTime.timer / 1000;
        let minutes = parseInt(`${seconds / 60}`);
        seconds = parseInt(`${seconds % 60}`);
        this.remainingTime.seconds =
          seconds < 10 ? '0' + seconds : `${seconds}`;
        this.remainingTime.minutes =
          minutes < 10 ? '0' + minutes : `${minutes}`;
        this.remainingTime.timer -= 1000;
        const borderValue = this.updateBorderColor(
          this.remainingTime.timer / 1000
        );
        this.renderer.setStyle(
          this.strokeCircle.nativeElement,
          'stroke-dashoffset',
          borderValue
        );
      });

    this.subscriptions.push(remainTimer);
  }

  updateBorderColor(remainingTime) {
    const percentage = (remainingTime / 120) * 190;
    const borderValue = 190 - percentage;
    return borderValue;
  }

  clearSearchField() {
    this.smsLoginForm.get('country_search').setValue('', { emitEvent: false });
    this.filteredCountryList = this.countryList;
  }

  unsubscribeTimer() {
    return this.remainingTime.timer < 1 ? false : true;
  }

  submitPhoneNumber() {
    if (!this.smsLoginForm.valid) {
      return;
    }
    const appVerifier = this.windowRef.recaptchaVerifier;
    const num =
      this.smsLoginForm.get('country_field')?.value?.phone_prefix +
      this.smsLoginForm.get('number')?.value;
    const auth = getAuth();
    if (this.isEditPhoneMode) {
      if (num === `+${this.profileData.phone_number}`) {
        this.snackBarService.showSnackBar(
          'New phone number must differ from current',
          'primary',
          2000
        );
        return;
      }

      this.panelService.checkPhoneNumberExists({ phone_number: num }).subscribe(
        (res) => {
          signInWithPhoneNumber(auth, num, appVerifier)
            .then((result) => {
              this.windowRef.confirmationResult = result;
              this.isVerificationStep = true;
              this.isEditPhoneVerifyMode.emit(2);
              this.startTimer();
              if (this.isEditPhoneMode) {
                this.snackBarService.showSnackBar(
                  `We've sent you a verification code`,
                  'primary',
                  2000
                );
              }
            })
            .catch((error) => {
              this.snackBarService.showSnackBar(error, 'primary', 2000);
              this.recaptchaChecked = false;
              this.isActionDisabled = true;
            });
        },
        (error) => {
          this.snackBarService.showSnackBar(
            error?.error?.detail,
            'primary',
            2000
          );
        }
      );
    } else {
      signInWithPhoneNumber(auth, num, appVerifier)
        .then((result) => {
          this.windowRef.confirmationResult = result;
          this.isVerificationStep = true;
          this.startTimer();
        })
        .catch((error) => {
          this.isActionDisabled = true;
          this.snackBarService.showSnackBar(error, 'primary', 2000);
        });
    }
  }
  onSubmitCode() {
    const form = this.verificationCodeForm.value;
    const verificationCode = Object.keys(form)
      .map((el) => form[el])
      .join('');
    if (!this.isNumber(verificationCode) || !this.smsLoginForm.valid) {
      return;
    }
    this.windowRef.confirmationResult
      .confirm(verificationCode)
      .then((result) => {
        this.isOtpCodeInvalid = false;
        if (this.isEditPhoneMode) {
          if (this.profileData?.phone_number) {
            this.firebaseValidateToken(result._tokenResponse.idToken);
          } else {
            this.authenticateService
              .firebaseConnect({ token: result._tokenResponse.idToken })
              .subscribe((res) => {
                this.googleTagManagerService.sendAnalytics('login', {
                  method: 'Google',
                });
                this.metaPixelService.pushEvent(
                  FACEBOOK_EVENT_TYPES.COMPLETE_REGISTRATION,
                  {
                    data: {
                      currency: 'no-data',
                      value: 1,
                      content_name: 'Google',
                    },
                  }
                );
                this.googleTagManagerService.sendAnalytics(
                  'conversion_event_signup',
                  { method: 'Google' }
                );
                this.profileResolver.updateInfo().then(() => {
                  this.zone.run(() => {
                    this.router.navigate(['/profile']);
                  });
                });
              });
          }
        } else {
          this.firebaseLogin(result._tokenResponse.idToken);
        }
      })
      .catch((error) => {
        this.isOtpCodeInvalid = true;
        this.snackBarService.showSnackBar(error.message, 'primary', 2000);
      });
  }

  firebaseValidateToken(token: any) {
    this.authenticateService.firebaseValidateToken({ token }).subscribe(
      (res) => {
        this.profileResolver.updateInfo().then(() => {
          this.zone.run(() => {
            this.router.navigate(['/profile']);
          });
        });
      },
      (error) => {
        this.snackBarService.showSnackBar(error.error.detail, 'primary', 2000);
      }
    );
  }

  firebaseLogin(token: any) {
    this.authenticateService.firebaseLogin({ token }).subscribe(
      (res) => {
        this.user = res.user;
        this.googleTagManagerService.sendAnalytics('login', { method: 'Sms' });
        this.googleTagManagerService.sendAnalytics('conversion_event_signup', {
          method: 'Sms',
        });
        this.metaPixelService.pushEvent(
          FACEBOOK_EVENT_TYPES.COMPLETE_REGISTRATION,
          {
            data: {
              currency: 'no-data',
              value: 1,
              content_name: 'Sms',
            },
          }
        );
        this.localStorage.setItem('accessToken', res.token);
        this.localStorage.setItem('refreshToken', res.refresh_token);
        this.stateService.setLoginStatus(true);
        this.profileResolver.updateInfo();
        this.stateService.setLoginStatus(true);
        if (this.buyingProductId) {
          let title = this.buyingProductName.replace(/[^a-zA-Z0-9]+/g, '-');
          this.zone.run(() => {
            this.router.navigate([`/product/${this.buyingProductId}/${title}`]);
          });
        } else {
          this.zone.run(() => {
            this.router.navigate(['/']);
          });
        }
      },
      (error) => {
        this.snackBarService.showSnackBar(error, 'primary', 2000);
      }
    );
  }

  resendCode() {
    this.verificationCodeForm.reset();
    this.reinitRecaptcha();
  }

  reinitRecaptcha() {
    const auth = getAuth();
    this.windowRef.recaptchaVerifier = new RecaptchaVerifier(
      'recaptcha-resend',
      {
        callback: () => {
          this.submitPhoneNumber();
        },
      },
      auth
    );
    this.windowRef.recaptchaVerifier.render();
  }

  isDisabled() {
    if (
      this.smsLoginForm.valid &&
      this.recaptchaChecked &&
      !this.isActionDisabled
    ) {
      return false;
    } else {
      return true;
    }
  }

  isVerificationStepDisabled() {
    return this.verificationCodeForm.invalid;
  }

  getBackToSubmitPhone() {
    this.unsubscribeTimer();
    this.isVerificationStep = false;
    this.isEditPhoneVerifyMode.emit(1);
    this.recaptchaChecked = false;
    this.isActionDisabled = true;
    this.verificationCodeForm.reset();
  }

  onSwitchInput(event: ClipboardEvent | any, prevEl, currentEl, nextEl, i) {
    const length = currentEl.value.length;
    const maxLength = currentEl.getAttribute('maxlength');
    if (currentEl.value.length > 1) {
      currentEl.value.slice(0, 1);
      this.verificationCodeForm
        .get(`character${i}`)
        .setValue(currentEl.value.slice(0, 1));
    }

    if (length == maxLength && nextEl) {
      nextEl.focus();
      nextEl.select();
    }

    if (event.key === 'Backspace' && prevEl) {
      prevEl.focus();
      prevEl.select();
    }

    if (!nextEl) {
      this.onSubmitCode();
    }
  }

  isNumber(str: any) {
    return !isNaN(str);
  }

  handlePaste(e) {
    let clipboardData, pastedData, formattedData;
    e.stopPropagation();
    e.preventDefault();

    clipboardData = e.clipboardData;
    pastedData = clipboardData.getData('Text');
    formattedData = pastedData.split('');
    if ([...e.target.classList].includes('otp-1')) {
      formattedData.map((el, index) => {
        this.verificationCodeForm.get(`character${index + 1}`).patchValue(el);
      });
      this.elementRef.nativeElement.querySelector('.otp-6').focus();
    }
  }

  closeDialogs() {
    this.dialog.closeAll();
  }
}
